import React from 'react';
import { Link } from 'react-router-dom';
import AuthShell from '../components/layout/AuthShell';

export default function PortalBlockedPage() {
  return (
    <AuthShell
      title="Portal access suspended"
      subtitle="Your student portal has been temporarily blocked due to unusual activity."
    >
      <div style={{ textAlign: 'center', color: '#64748b', fontSize: 14, lineHeight: 1.6 }}>
        <span
          className="material-symbols-outlined"
          style={{ fontSize: 48, color: '#ef4444', display: 'block', marginBottom: 16 }}
        >
          gpp_bad
        </span>
        <p>
          Copying content, taking screenshots, or repeated security violations can lead to a block.
          Please contact Success Bridge Academy to reactivate your account.
        </p>
        <Link to="/" className="sba-auth-btn-primary" style={{ display: 'inline-block', marginTop: 20 }}>
          Return to website
        </Link>
      </div>
    </AuthShell>
  );
}
